import SafeRedirect from './safeRedirect';

export default SafeRedirect;
